{
  "dynamic": {
    "CONFIRM_CLEAR_PALETTE": "Are you sure you want to clear the color palette? This operation cannot be undone.",
    "CONFIRM_DELETE_OBJECT": "Are you sure you want to delete the object? This operation cannot be undone.",
    "CONFIRM_LOAD_BACKUP": "Are you sure this will clear the data you are working on? This operation cannot be undone.",
    "ALERT_NOSUPPORT_COPY": "Sorry! Your environment doesn't permit to access the clipboard.",
    "ALERT_CLIPBOARD_DATA_ERROR": "Your browser says \"No valid data on clipboard.\" but Ctrl+V may work.",
    "ALERT_CLIPBOARD_DATA_ERROR_PALETTE": "Your browser says \"No valid data on clipboard.\" The image copied from a local file seems not to work due to browser restriction or bug."
  }
}